document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".banner-carousel-swiper").forEach((element) => {
    if (element.closest(".banner-carousel--single")) return;

    new Swiper(element, {
    slidesPerView: "auto",
    spaceBetween: 12,
    slideToClickedSlide: true,
    grabCursor: true,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: element.querySelector(".swiper-pagination"),
      clickable: true,
    },
     mousewheel: {
      forceToAxis: true,
      thresholdDelta: 10,
      sensitivity: 1,
      releaseOnEdges: true
    },
    breakpoints: {
      1440: {
        spaceBetween: 20,
      },
    }
    });
  });
});
